module.exports = __webpack_public_path__ + "static/img/legend_xg_english_dark_vertical.c1f569a.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/legend_xg_english_dark_vertical.png
// module id = cKRc
// module chunks = 94